import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../models/https';
import { IWarehouseAreaListResponse } from '../../models/warehouse/warehouseArea.model';
import useHttps from '../useHttps';

const useWarehouseArea = () => {
  const { stateId } = useParams();
  const request = useHttps();
  const [warehouseArealoading, setWarehouseAreaLoading] = useState(false);
  const [listOfWarehousesArea, setListOfWarehousesArea] =
    useState<IWarehouseAreaListResponse[]>();

  useEffect(() => {
    const getWarehousesArea = () => {
      const url: HttpConfig = {
        url: `general-service/v1/commons/states/${stateId}/areas`,
        method: 'get',
      };

      request(
        url,
        onListWarehousesAreaSuccess,
        setWarehouseAreaLoading,
        onListWarehousesAreaError
      );
    };
    getWarehousesArea();
  }, [request, stateId]);

  const onListWarehousesAreaError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while creating clearer'
    );
  };

  const onListWarehousesAreaSuccess = ({
    message,
    data,
  }: SuccessHttpResponse<IWarehouseAreaListResponse[]>) => {
    // console.log('data--->>', data);
    const wareHouseIdsList = data.map((data: IWarehouseAreaListResponse) => ({
      name: data.name,
      code: data.code,
    }));
    setListOfWarehousesArea(wareHouseIdsList);
    // toast.success(message);
  };

  return { listOfWarehousesArea, warehouseArealoading };
};

export default useWarehouseArea;
